module.exports = __webpack_public_path__ + "static/media/proj20_img19.893c5c87.jpg";